import { IApiFile } from "@propely/propely-typings";
import { GlobalFileData } from "../../../to-be-removed/LocalData/Files/GlobalFileData";
import { FileDocumentData } from "../../../to-be-removed/LocalData/General/FileDocumentData";
import { FirebaseFile } from "../../../to-be-removed/LocalData/General/FirebaseFile";
import { Popup } from "../Popup/Popup";
import styles from "./FileLabel.module.css";
import { FilePopup } from "./FilePopup";

type Props = {
  file: FileDocumentData | FirebaseFile | GlobalFileData | IApiFile;
  otherFiles?: (FileDocumentData | FirebaseFile)[];
  dataCy?: string;
};

export const FileLabel = ({ file, otherFiles, dataCy }: Props) => {
  function launchFilePopup() {
    Popup.present((id) => <FilePopup id={id} file={file} otherFiles={otherFiles} />);
  }

  return (
    <div data-cy={dataCy} onClick={() => launchFilePopup()} className={styles.fileLabel}>
      {file instanceof FileDocumentData || file instanceof GlobalFileData ? file.name : file instanceof FirebaseFile ? file.title : file.name}
    </div>
  );
};

